import {combineReducers} from '@modifi/redux'
import dataReducer, {featureReducer} from './store'

export default combineReducers({
  data: dataReducer,
  feature: featureReducer,
})

export {
  aFetchTransactions,
  aDeleteTransactionEntity,
  aSetRelevantFlag,
  selectTransactionsByKeyWindow,
  selectTransactionsIsKeyWindowLoading,
  selectTransactionById,
  selectRelevantFlag,
} from './store'
